<div class="dialog">
  <header class="dialog__header">
    <h3 class="dialog__header__title"></h3>
    <div class="dialog__header__action-buttons">
      @if (!alertType && (isUserOwner || isUserAdmin)) {
        <div class="dialog__header__action-buttons__button" (click)="editEventDetailsDialog()">
          <span>
            <app-icon iconName="pencil" size="18px" [style.cursor]="'pointer'"></app-icon>
          </span>
        </div>
      }
      @if (isUserOwner || isUserAdmin) {
        <div class="dialog__header__action-buttons__button" (click)="deleteEvent(currentSelectedEvent)">
          <span>
            <app-icon iconName="trash-bin" size="18px" [style.cursor]="'pointer'"></app-icon>
          </span>
        </div>
      }
      <div (click)="closeDialog()" class="dialog__header__action-buttons__button">
        <span>
          <app-icon iconName="close" size="20px"></app-icon>
        </span>
      </div>
    </div>
  </header>

  <div class="dialog__content">
    @if (!loadings.eventDetails) {
      @if (alertType) {
        <app-alert-message [alertType]="alertType" [denyReason]="currentSelectedEvent.denyReason" [showCloseIcon]="false" [size]="'small'" marginTop="20px"></app-alert-message>
      }

      @if (showUpdatedRecord && isUserAdmin) {
        <app-tabs-selection (selectedTab)="onUpdateRecordTabSelection($event)" [tabs]="updateSelectionTabs" [selectedTabName]="currentUpdatedRecordTab" marginBottom="30px"></app-tabs-selection>
      }

      <div class="event-details">
        <div class="image-wrapper background-loading mt-16">
          <img [src]="currentSelectedEvent?.imageUrl" [alt]="currentSelectedEvent?.name" appDefaultImage="assets/images/defaults/event.png" loading="lazy" />
        </div>
        <h2 class="event-details__heading mt-20">{{ currentSelectedEvent.name || '' }}</h2>

        <!-- Participants -->
        <div class="d-flex justify-content-between align-items-center mt-16">
          @if (currentSelectedEvent?.participants?.length) {
            <div class="participants">
              <div class="participant-avatar">
                @if (currentSelectedEvent?.participants?.length > 3) {
                  <p class="participant-count-badge">+{{ currentSelectedEvent?.participants?.length - 3 }}</p>
                }
                @for (participant of currentSelectedEvent?.participants.slice(0, 3); track participant.id || $index) {
                  <a class="avatar-image background-loading-tiny">
                    <img [appFetchProfileImage]="participant?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                  </a>
                }
              </div>
            </div>
          }
          <!-- Set of Buttons To Accept Deny -->
          <div class="flex-row-end-center gap-10 ml-auto">
            @if (!currentSelectedEvent?.denyById && currentSelectedEvent?.approvedStatus === ApprovedStatus.Approved) {
              <div class="flex-row-end-center gap-10">
                @if (!isUserJoinedCurrentDate && !canUserAccept) {
                  <!--                    <app-button (clickEvent)="joinEvent(currentSelectedEvent, $event)" [idleText]="'Join Event' | translate" cssClass="button-primary-outline button-small" size="small"></app-button>-->

                  <app-button
                    [tippy]="joinMenu"
                    className="popper-menu z-9999"
                    [idleText]="'Join Event' | translate"
                    cssClass="button-primary-outline button-small"
                    size="small"
                    variation="popper"
                    placement="bottom-start"
                  >
                  </app-button>
                }

                @if (canUserLeaveEvent) {
                  <app-button (clickEvent)="leaveEvent(currentSelectedEvent, $event)" [idleText]="'Leave Event' | translate" cssClass="button-secondary-outline button-small" size="small">
                  </app-button>
                }

                @if (canUserAccept) {
                  <app-button
                    [tippy]="joinMenu"
                    className="popper-menu z-9999"
                    size="small"
                    variation="popper"
                    [data]="{ type: 'accept-event' }"
                    placement="bottom-start"
                    [idleText]="'Accept event' | translate"
                    cssClass="button-primary-outline button-small"
                    size="small"
                  >
                  </app-button>
                }

                @if (canUserDeny) {
                  <app-button (clickEvent)="denyInvitedEvent(currentSelectedEvent, $event)" [idleText]="'Deny event' | translate" cssClass="button-secondary-outline button-small" size="small">
                  </app-button>
                }
              </div>
            }

            @if (currentSelectedEvent?.document) {
              <button (click)="downloadDocument(currentSelectedEvent)" [disabled]="loadings.downloadingDocument" [tippy]="'Download File' | translate" class="button button-simple button-icon-only">
                <app-icon iconName="download"></app-icon>
              </button>
            }
          </div>

          <!-- Set of Buttons To Approve/Publish and deny -->
          @if (isUserAdmin && !isUserOwner && isStatusUnapproved && !currentSelectedEvent?.denyById) {
            <div class="flex-row-end-center gap-10 ml-auto">
              <app-button (clickEvent)="approveEvent($event)" [idleText]="'Publish event' | translate" cssClass="button-primary-outline button-small" size="small"></app-button>
              <app-button (clickEvent)="unApproveEvent($event)" [idleText]="'Deny event' | translate" cssClass="button-secondary-outline button-small" size="small"></app-button>
            </div>
          }
        </div>

        <p class="event-details__text mt-16" [innerHTML]="currentSelectedEvent.description"></p>

        <div class="main-area">
          <!-- Date -->
          <div class="row mt-16">
            <div class="col-lg-4">
              <div class="d-flex align-items-center">
                <app-icon iconName="calendar"></app-icon>
                <p class="label-text ml-14" translate>dates&filters.date</p>
              </div>
            </div>
            <div class="col-lg-6">
              @if (
                ((showUpdatedRecord && currentUpdatedRecordTab === UpdateTabType.UPDATE) || currentSelectedEvent?.approvedStatus === ApprovedStatus.UnApproved) &&
                currentSelectedEvent?.recurrence &&
                currentSelectedEvent?.recurrence !== ''
              ) {
                <p class="event-details__text">{{ getRecurrenceInfo }}</p>
              } @else if (
                (((showUpdatedRecord && currentUpdatedRecordTab === UpdateTabType.UPDATE) || currentSelectedEvent?.approvedStatus === ApprovedStatus.UnApproved) &&
                  !currentSelectedEvent?.recurrence) ||
                currentSelectedEvent?.recurrence === ''
              ) {
                @for (rec of currentSelectedEvent?.recurringDates; track rec.dateFrom + rec.startTime + $index; let last = $last) {
                  <p class="event-details__text">
                    {{ rec.dateFrom | date: 'dd.MM.y' }}
                    @if (rec.dateEnd !== rec.dateFrom) {
                      - {{ rec.dateEnd | date: 'dd.MM.y' }}
                    }
                    @if (!last) {
                      ,
                    }
                  </p>
                }
              } @else {
                <p class="event-details__text">
                  {{
                    currentSelectedEvent.currentDate
                      ? (currentSelectedEvent.currentDate | date: 'dd.MM.y')
                      : currentSelectedEvent?.recurringDates?.length
                        ? (currentSelectedEvent?.recurringDates[0]?.dateFrom | date: 'dd.MM.y')
                        : ''
                  }}
                  @if (!currentSelectedEvent?.recurrence && currentRecurringDates?.dateEnd) {
                    @if (currentRecurringDates.dateEnd !== currentSelectedEvent.currentDate && currentRecurringDates.dateEnd !== currentSelectedEvent?.recurringDates[0]?.dateFrom) {
                      - {{ currentRecurringDates.dateEnd | date: 'dd.MM.y' }}
                    }
                  }
                </p>
              }
            </div>
          </div>

          <!-- Time -->
          <div class="row mt-16">
            <div class="col-lg-4">
              <div class="d-flex align-items-center">
                <app-icon iconName="clock"></app-icon>
                <p class="label-text ml-14" translate>dates&filters.time</p>
              </div>
            </div>
            <div class="col-lg-6">
              @if (isNonRecurringSingleDate) {
                <!-- Single non-recurring event -->
                <p class="event-details__text">
                  {{ currentRecurringDates?.startTime }} - {{ currentRecurringDates?.endTime }}
                  <span translate>Clock</span>
                </p>
              } @else if (isNonRecurringMultipleDatesInUpdateMode || this.currentSelectedEvent.approvedStatus === ApprovedStatus.UnApproved) {
                <!-- Multiple dates in "update" mode -->
                @for (rec of currentSelectedEvent?.recurringDates; track rec.dateFrom + rec.startTime + $index; let last = $last) {
                  <p class="event-details__text">
                    {{ rec.startTime }} - {{ rec.endTime }}
                    <span translate>Clock</span>
                    @if (!last) {
                      ,
                    }
                  </p>
                }
              } @else if (isNonRecurringMultipleDates) {
                <!-- Multiple dates not in "update" mode -->
                <p class="event-details__text">
                  {{ currentRecurringDates.startTime }} - {{ currentRecurringDates.endTime }}
                  <span translate>Clock</span>
                </p>
              } @else {
                <!-- Recurring event -->
                <p class="event-details__text">
                  {{ getRecurringEventTime('startTime') }} - {{ getRecurringEventTime('endTime') }}
                  <span translate>Clock</span>
                </p>
              }
            </div>
          </div>

          <!-- Location -->
          <div class="row mt-16">
            <div class="col-lg-4">
              <div class="d-flex align-items-center">
                <app-icon iconName="marker"></app-icon>
                <p class="label-text ml-14" translate>appointmentAndClub.location</p>
              </div>
            </div>
            <div class="col-lg-6">
              <p class="event-details__text">{{ currentSelectedEvent?.place }}</p>
            </div>
          </div>

          <!-- Price -->
          @if (+currentSelectedEvent?.chargeable) {
            <div class="row mt-16">
              <div class="col-lg-4">
                <div class="d-flex align-items-center">
                  <app-icon iconName="euro"></app-icon>
                  <p class="label-text ml-14" translate>Price</p>
                </div>
              </div>

              @if (currentSelectedEvent?.chargeable) {
                <div class="col-lg-6">
                  @if (currentSelectedEvent?.chargeable !== '0') {
                    <p class="event-details__text">€&nbsp;{{ currentSelectedEvent?.chargeable }}</p>
                  } @else {
                    <p class="event-details__free">{{ 'Free' | translate }}</p>
                  }
                </div>
              }
            </div>
          }

          <!-- Author -->
          <div class="row align-items-center mt-16">
            <div class="col-lg-4">
              <div class="d-flex align-items-center">
                <app-icon iconName="user"></app-icon>
                <p class="label-text ml-14" translate>appointmentAndClub.responsible</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="participants cursor-pointer" (click)="navigateToChat()">
                <div class="participant-avatar">
                  <a class="avatar-image background-loading-tiny">
                    <img [appFetchProfileImage]="+admin?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                  </a>
                </div>
                <p class="event-details__text">
                  {{ admin?.user?.fullName || admin?.user?.firstName + ' ' + admin?.user?.lastName }}
                </p>
              </div>
            </div>
          </div>

          <!-- Group -->
          @if (currentSelectedEvent?.group && currentSelectedEvent?.group?.name) {
            <div class="row align-items-center mt-16">
              <div class="col-lg-4">
                <div class="d-flex align-items-center">
                  <app-icon iconName="user-pair"></app-icon>
                  <p class="label-text ml-14" translate>Group</p>
                </div>
              </div>
              <div class="col-lg-6">
                <app-badge class="cursor-pointer" (click)="navigateToGroupDetails(currentSelectedEvent?.group?.id)" [borderRadius]="'6px'" [text]="currentSelectedEvent?.group?.name"></app-badge>
              </div>
            </div>
          }

          <!--  WORK SHIFT SECTION DISABLED on request from MANAGER  -->
          <!-- Work Shifts -->
          <!--          <ng-container *ngIf="canViewWorkShifts && currentSelectedEvent?.eventShifts && currentSelectedEvent?.eventShifts?.length">-->
          <!--            <div class="row align-items-center mt-16">-->
          <!--              <div class="col-lg-4">-->
          <!--                <div class="d-flex align-items-center">-->
          <!--                  <app-icon iconName="timer"></app-icon>-->
          <!--                  <p class="label-text ml-14" translate>Work Shifts</p>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="col-lg-6">-->
          <!--                <a (click)="$event.preventDefault(); $event.stopPropagation(); openWorkShiftDetails(shiftsDetailsModal)" class="event-details__text" href="#" translate> Click to open details </a>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </ng-container>-->

          <!--  Tags -->

          @if (currentSelectedEvent?.eventTags && currentSelectedEvent?.eventTags.length) {
            <div class="row align-items-start mt-16">
              <div class="col-lg-4">
                <div class="d-flex align-items-center">
                  <app-icon iconName="hash"></app-icon>
                  <p class="label-text ml-14" translate>Tags</p>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="flex-row-start-center gap-6 flex-wrap">
                  @for (tag of currentSelectedEvent.eventTags; track tag.tagId || tag.tagName + $index) {
                    <p class="event-details__text tag tag-display mr-1">{{ tag?.tagName | humanize | truncateText: 30 }}</p>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Dynamic Tabs For participants -->
        <div class="event-details__participants mt-24">
          <app-dynamic-tabs>
            <ng-template [count]="uniqueJoinedParticipantsCount" [tabName]="'appointmentAndClub.confirmed' | translate">
              <div class="row g-3">
                @for (participant of currentSelectedEvent?.participants; track participant.id || $index) {
                  @if (participant?.approvedStatus === ApprovedStatus.Approved && hasParticipantJoinedCurrentDate(participant)) {
                    <div class="col-md-6 col-lg-6">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="user-image-wrapper background-loading-tiny">
                          <img [appFetchProfileImage]="participant?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                        </div>
                        <h2>{{ participant?.user?.fullName | translate }}</h2>
                      </div>
                    </div>
                  }
                }
              </div>
            </ng-template>

            @if (isAllowedToViewPendingAndCancelledMembers) {
              <ng-template [count]="pendingParticipantsCount" [tabName]="'appointmentAndClub.pending' | translate">
                <div class="row g-3">
                  @for (participant of currentSelectedEvent.participants; track participant.id || $index) {
                    @if (participant.approvedStatus === ApprovedStatus.UnApproved) {
                      <div class="col-md-6 col-lg-6">
                        <div class="flex-row-start-center">
                          <div class="user-image-wrapper background-loading-tiny">
                            <img [appFetchProfileImage]="participant?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                          </div>
                          <h2>{{ participant?.user?.fullName ?? participant?.user?.firstName + ' ' + participant?.user?.lastName | translate }}</h2>
                        </div>
                      </div>
                    }
                  }
                </div>
              </ng-template>

              @if (isUserAdmin) {
                <ng-template [count]="rejectedParticipantsCount" [tabName]="'appointmentAndClub.canceled' | translate">
                  <div class="row g-3">
                    @for (participant of currentSelectedEvent.participants; track participant.id || $index) {
                      @if (participant.approvedStatus === ApprovedStatus.Rejected) {
                        <div class="col-md-6 col-lg-6">
                          <div class="d-flex justify-content-start align-items-center">
                            <div class="user-image-wrapper background-loading-tiny">
                              <img [appFetchProfileImage]="participant?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                            </div>
                            <h2>{{ participant?.user?.fullName | translate }}</h2>
                          </div>
                        </div>
                      }
                    }

                    <!-- Users who left the event on current date -->
                    @for (userLeaveDate of currentSelectedEvent.userLeaveDates; track userLeaveDate.id || $index) {
                      @if (hasUserLeftCurrentDate(userLeaveDate)) {
                        <div class="col-md-6 col-lg-6">
                          <div class="d-flex justify-content-start align-items-center">
                            <div class="user-image-wrapper background-loading-tiny">
                              <img [appFetchProfileImage]="userLeaveDate?.user?.memberId" alt="" loading="lazy" src="assets/images/placeholder.png" />
                            </div>
                            <div class="d-flex flex-column">
                              <h2>{{ userLeaveDate?.user?.firstName + ' ' + userLeaveDate?.user?.lastName | translate }}</h2>
                              <!--                              <app-badge [text]="'Left' | translate"></app-badge>-->
                            </div>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </ng-template>
              }
            }
          </app-dynamic-tabs>
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
  </div>

  @if (showUpdatedRecord && isUserAdmin) {
    <footer class="dialog__footer">
      <div class="dialog__footer__buttons">
        <app-button (clickEvent)="unApproveEvent($event)" [idleText]="'Deny' | translate" cssClass="button-simple"></app-button>
        <app-button (clickEvent)="approveEvent($event, true)" [idleText]="'Publish' | translate"></app-button>
      </div>
    </footer>
  }
</div>

<!--<ng-template #shiftsDetailsModal let-ref>-->
<!--  <div class="event-work-shifts-grid">-->
<!--    <ng-container *ngIf="currentSelectedEvent?.eventShifts && currentSelectedEvent?.eventShifts?.length">-->
<!--      <ng-container *ngFor="let shift of currentSelectedEvent.eventShifts">-->
<!--        <app-work-shift-card [hideActions]="true" [shift]="shift"></app-work-shift-card>-->
<!--      </ng-container>-->
<!--    </ng-container>-->
<!--  </div>-->
<!--</ng-template>-->

<ng-template #loading>
  <div class="loadings">
    <ngx-skeleton-loader [theme]="{ width: '98%', height: '240px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '98%', height: '30px', borderRadius: '10px' }" appearance="circle" count="1" />

    <div class="participants-loaders">
      @for (_ of [].constructor(4); track $index) {
        <ngx-skeleton-loader [theme]="{ width: '36px', height: '36px' }" appearance="circle" count="1" />
      }
    </div>

    <ngx-skeleton-loader [theme]="{ width: '80%', height: '50px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '60%', height: '30px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '60%', height: '30px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '60%', height: '30px', borderRadius: '10px' }" appearance="circle" count="1" />

    <ngx-skeleton-loader [theme]="{ width: '98%', height: '70px', borderRadius: '10px' }" appearance="circle" count="1" />
  </div>
</ng-template>

<ng-template #joinMenu let-data="data" let-hide>
  <div class="popper-menu-content" style="width: 200px">
    <ul>
      @if (currentSelectedEvent.currentDate) {
        <li (click)="joinEventOnSingleDate(currentSelectedEvent); hide()">
          <app-icon iconName="calendar-check"></app-icon>
          <label translate>{{ data?.type === 'accept-event' ? 'Accept This Event' : 'Join This Event' }}</label>
        </li>
      }
      <li (click)="joinAllEventsInSeries(currentSelectedEvent); hide()">
        <app-icon iconName="calendar"></app-icon>
        <label translate>{{ data?.type === 'accept-event' ? 'Accept All Events in Series' : 'Join All Events in Series' }}</label>
      </li>
      <li (click)="openEventDatesSelectionDialog(currentSelectedEvent); hide()">
        <app-icon iconName="calendar-date"></app-icon>
        <label translate>{{ data?.type === 'accept-event' ? 'Accept Event on Specific Dates' : 'Join Event on Specific Dates' }}</label>
      </li>
    </ul>
  </div>
</ng-template>
